<template>
  <div v-if="
    get('galleries') != 0 &&
    get('galleries').some((gallery) => gallery.published)
  ">
    <v-row class="pa-0 ma-0">
      <span
        @click="linkTo('galleries')"
        class="mt-4 mb-4 text-h5 font-weight-black click_cursor"
      >{{ $t('gallery.consumer.slider.title') }}</span>
    </v-row>
    <div v-if="get('galleries') != 0">
      <vueper-slides
        class="no-shadow"
        :visible-slides="5"
        slide-multiple
        pauseOnHover
        :breakpoints="breakpoints"
        :gap="1"
        fixed-height="350px"
        :dragging-distance="20"
        :arrows-outside="false"
        :bullets="false"
      >
        <!-- @before-slide="loadMoreGalleries" -->
        <vueper-slide
          v-for="(gallery, index) in filteredPublishedGalleries"
          :key="index"
        >
          <template #content>
            <GalleryCard
              :gallery="gallery"
              @click="openGallery(gallery)"
            />
          </template>
        </vueper-slide>
        <!-- 
				<div class="d-flex align-center justify-center full-w" style="min-width: 33%;">
					<v-btn @click="linkTo('galleries')" outlined xxl-large>Weitere Galerien</v-btn>
				</div> -->
      </vueper-slides>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AppService from "@/services/app.service";
import APIService from "@/services/api.service";
import { VueperSlides, VueperSlide } from "vueperslides";
import "vueperslides/dist/vueperslides.css";
import moment from "moment";

export default {
  name: "gallerySlider",

  props: ["gallery"],
  components: {
    VueperSlides,
    VueperSlide,
    GalleryCard: () => import('../../components/galleryCard'),
  },

  data() {
    return {
      title: "",
      description: "",
      published: false,
      breakpoints: {
        1800: {
          visibleSlides: 3,
          slideMultiple: 3,
        },
        1199: {
          visibleSlides: 2,
          slideMultiple: 2,
        },
        800: {
          visibleSlides: 1,
          bulletsOutside: true,
        },
      },
    };
  },

  computed: {
    ...mapGetters(["get"]),
    filteredPublishedGalleries() {
      return this.$store.state.main.galleries.result.filter((gallery) => {
        return gallery.published == true;
      });
    },
  },

  methods: {
    imageSource(image, width, height) {
      return AppService.imageSourceWithToken(image, width, height);
    },

    linkToGalleryImages(galleryId) {
      // The target view loads page one with its limit. A fetch without limit
      // here would break the pager of the target view.
      this.$router.push(`gallery/${galleryId}/images`);
    },

    // loadMoreGalleries(){
    // 	this.loadMore()
    // },

    formDate(value) {
      if (value) {
        return moment(String(value)).format("DD.MM.YYYY");
      }
    },

    isTester() {
      return AppService.isTester();
    },
    isCreatorSubActive() {
      return AppService.isCreatorSubActive();
    },

    openModal(name) {
      this.$store.dispatch("modal/open", name);
    },

    linkTo(route, query) {
      this.$router.push(query ? { path: "/" + route, query } : "/" + route);
    },

    checkAccess(gallery) {
      if (gallery.price > 0) {
        return AppService.isPaid(gallery, "gallery");
      }
      if (gallery.subscription) {
        return AppService.isSubscription(gallery);
      }
      return true;
    },

    isPaid(item, type) {
      return AppService.isPaid(item, type);
    },

    isSubscription(item) {
      return AppService.isSubscription(item);
    },

    zeitInText(date) {
      return AppService.getTimeElapsed(date);
    },

    isFree(item) {
      let free = false;
      if (item.price == 0 && item.subscription == false) {
        free = true;
      }
      return free;
    },

    openGallery(gallery) {
      if (gallery.price > 0) {
        if (!AppService.isPaid(gallery, 'gallery')) {
          return this.addToCart(gallery)
        }
      }
      if (gallery.subscription) {
        if (!AppService.isSubscription(gallery)) {
          return this.linkTo('subcheckout', { content: 'gallery', cid: gallery.id });
        }
      }
      if (gallery.fsk == 18 && !AppService.isAgeVerified()) {
        return this.linkTo('ageVerification')
      }
      return this.linkToGalleryImages(gallery.id);
    },

    addToCart(gallery) {
      this.$store.dispatch('fetch', { endpoint: '/api/v1/cart', state: 'cart' })

      const cartItems = this.$store.state.main.cart.result;
      const product_id = gallery.id;
      const isGallery = Array.isArray(gallery.images) && gallery.images.length > 0;

      const isProductIdPresent = (arr, productId) => {
        return arr.some(obj => obj.product_id === productId); // Geändert: wie bei Einzelbildern
      };

      if (!this.isPaid(gallery, 'gallery') && !isProductIdPresent(cartItems, product_id)) {
        this.$store.dispatch('post', {
          endpoint: `/api/v1/cart`,
          state: 'cart',
          event: { type: "Gallery", productId: product_id },
          message: false,
        }).then(() => {
          this.$store.dispatch('fetch', { endpoint: '/api/v1/cart', state: 'cart' });
          APIService.setResponse({ message: this.$t('cart.added_notice'), color: "green" });
          this.$root.$emit('cart:item-added');
        })
      } else {
        APIService.setResponse({ message: this.$t('cart.already_notice'), color: "red" });
      this.$root.$emit('cart:item-added');
      }
    },
  },
};
</script>
